import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef, TemplateRef } from "@angular/core";
import { FlowTemplate } from "../../../common/models/flow.dto";
import { LunaEntity, EntityMap, PropertyMap, RelatedEntityMap} from "../../models/entity.model";
import { deepClone } from "../../models/editor.model";
import { genId } from "../../../core/services/genId";
import { EntityBuilderService } from "../../services/entity-builder.service";


@Component({
    templateUrl: "./workflow-entity-map.component.html",
    selector: "workflow-entity-map",
    styleUrls: ["./workflow-entity-map.component.scss"],
    standalone: false
})

export class WorkflowEntityMapComponent implements OnInit {

    @Input() template: FlowTemplate;
    @Input() entity: LunaEntity;
    @Input() contextValue: string;

    @Input() propertyMap: PropertyMap;
    @Input() entityName: string;
    @Input() entityMap: EntityMap | RelatedEntityMap | null;

    @Output() mapCreated = new EventEmitter<EntityMap>();

    @ViewChild("objMap", {
    read: ViewContainerRef,
    static: true
}) objMap: ViewContainerRef;

    @ViewChild("submap", {
    read: TemplateRef,
    static: true
}) subMap: TemplateRef<any>;

    @ViewChild("arrayMap", {
    read: TemplateRef,
    static: true
}) arrayMap: TemplateRef<any>;

    useFunction: boolean = false;

    constructor(private entitybuilderSrv:EntityBuilderService) {
        
    }

    ngOnInit(): void {
        if (!this.propertyMap.isPrimitive) {
            this.pushNewNode(this.propertyMap.allowMultipleMaps);
        }
    }

    pushNewNode(useArray: boolean): void {
        const view = (useArray) ? this.arrayMap.createEmbeddedView(null) :  this.subMap.createEmbeddedView(null);
        this.objMap.insert(view);
    }

    pasteContext(property: string): void {
        this.propertyMap.contextPath = `$.${this.contextValue}`;
    }

    isRelationalProperty(map: PropertyMap): boolean {
        if (!this.entitybuilderSrv.isRelationalMap(this.entityMap)) return false;
        const relational = this.entityMap as RelatedEntityMap;
        return relational.relationalProperty === map.propertyName;
    }

    fixNameCasing(name: string): string {
        if (!name) return this.propertyMap.toString(); // map itself is a string primitive
        let result: string = "";
        let lastChar = name.substring(0, 1).toUpperCase();
        result = result.concat(lastChar);
        for (let s = 1; s < name.length; s++) {
            const nextChar = name.substring(s, s + 1);
            if (nextChar === nextChar.toUpperCase() && lastChar !== lastChar.toUpperCase()) {
                result = result.concat(" ");
            }
            result = result.concat(nextChar);
            lastChar = nextChar;
        }
        return result;
    }

    getPropertyType(type: any): string {
        if (!type) {
            return this.propertyMap.toString();
        } else {
            if (Array.isArray(type) && type.length > 0) {
                if (this.getPrimitive(type[0])) {
                    return type[0].propertyType.toString();
                } else {
                    return "object";
                }
            } else {
                return type.toString();
            }
        }
    }

    isPrimitive(obj: any): boolean {
        if (Array.isArray(obj)) {
            return this.getPrimitive(obj[0]);
        }
        return this.getPrimitive(obj);
    }

    getPrimitive(obj: any): boolean {
        if (Array.isArray(obj)) return false;
        const primitive = Object.keys(obj).filter(k => k === "isPrimitive");
        if (primitive && primitive.length > 0) {
            return obj.isPrimitive;
        } else {
            return true;
        }
    }

    addNode(data: any): void {
        const clone = deepClone(data[0]);
        this.voidPaths(clone);
        data.push(clone);
    }

    voidPaths(clone: any): void {
        clone.contextPath = "";
        if (!this.getPrimitive(clone)) {
            for (let i = 0; i < clone.propertyType.length; i++) {
                this.voidPaths(clone.propertyType[i]);
            }
        }
    }
}